import { foldInstallMode } from '../../../records/InstallMode/InstallMode';
import { isInstallStatusLoading } from '../../../records/InstallMode/InstallStatus';
import resolveDialogAppSpecificPassword from '../components/DialogAppSpecificPassword';
import resolveDialogDefault from '../components/DialogDefault';
import resolveDialogDetermining from '../components/DialogDetermining';
import resolveDialogInstallByManualUrl from '../components/DialogInstallByManualUrl';
import resolveDialogInstructional from '../components/DialogInstructional';
import resolveDialogUpgrade from '../components/DialogUpgrade';
export default function resolveDialog(installMode, config, featureFlags) {
  return foldInstallMode(installMode)(determiningInstallMode => resolveDialogDetermining({
    closeInstallDialog: config.closeInstallDialog,
    determiningInstallMode,
    hostConfig: config.hostConfig,
    featureFlags
  }), appSpecificPasswordInstallMode => resolveDialogAppSpecificPassword({
    appSpecificPasswordInstallMode,
    closeInstallDialog: config.closeInstallDialog,
    context: config.context,
    generateAppSpecificPassword: config.generateAppSpecificPassword,
    hostConfig: config.hostConfig,
    hostPricing: config.hostPricing,
    openManualUrlInstallDialog: config.openManualUrlInstallDialog,
    openAppSpecificPasswordDialog: config.openAppSpecificPasswordDialog,
    setAppSpecificPasswordName: config.setAppSpecificPasswordName
  }), instructionalInstallMode => resolveDialogInstructional({
    closeInstallDialog: config.closeInstallDialog,
    instructionalInstallMode,
    links: config.links
  }), defaultInstallMode => resolveDialogDefault({
    closeInstallDialog: config.closeInstallDialog,
    context: config.context,
    defaultInstallMode,
    hostConfig: config.hostConfig,
    hostPricing: config.hostPricing,
    installApp: config.installApp,
    hostInfo: config.hostInfo,
    links: config.links,
    scopesLookup: config.scopesLookup,
    mpacBaseUrl: config.mpacBaseUrl,
    featureFlags,
    isInstallInProgress: () => isInstallStatusLoading(defaultInstallMode.status)
  }), installableAppByManualUrlInstallMode => resolveDialogInstallByManualUrl({
    clearInstallableAppByManualUrl: config.clearInstallableAppByManualUrl,
    closeInstallDialog: config.closeInstallDialog,
    context: config.context,
    fetchInstallableAppByManualUrl: config.fetchInstallableAppByManualUrl,
    hostConfig: config.hostConfig,
    installableAppByManualUrlInstallMode,
    installApp: config.installApp,
    hostInfo: config.hostInfo,
    links: config.links,
    openManualUrlInstallDialog: config.openManualUrlInstallDialog,
    openAppSpecificPasswordDialog: config.openAppSpecificPasswordDialog,
    scopesLookup: config.scopesLookup,
    featureFlags
  }), upgradeInstallMode => resolveDialogUpgrade({
    closeInstallDialog: config.closeInstallDialog,
    context: config.context,
    hostConfig: config.hostConfig,
    hostPricing: config.hostPricing,
    links: config.links,
    scopesLookup: config.scopesLookup,
    upgradeApp: config.upgradeApp,
    upgradeInstallMode,
    featureFlags
  }));
}